import { http } from 'interfaces'
import { type Person } from 'services'
import type { MissingValueFilter } from 'components'
export interface PersonFilterRequest {
  id?: string
  uniqueid?: string
  first_name?: string
  last_name?: string
  country?: number[]
  email?: string
  positionTypeIds?: number[]
  page?: number
  page_size?: number
  order_by: string
  order_direction: 'ASC' | 'DESC'
}

export const missingValueFilters: Record<string, MissingValueFilter> = {
  Email: { label: 'Email', query: 'no_email', value: 1 },
  Phone: { label: 'Phone', query: 'no_phone', value: true },
  LastName: { label: 'Last Name', query: 'no_last_name', value: true },
  Address: { label: 'Address', query: 'no_address', value: true }
}

export const addMissingValueInParams = (params: any, missingValue: MissingValueFilter): void => {
  params[missingValue.query] = missingValue.value
}

export interface PersonFilterResults {
  data: Person[]
  page_number: number
  page_size: number
  total_pages: number
  total_items: number
}

export async function personListFilter (params: any): Promise<PersonFilterResults> {
  return await http.get('/api/v1/people/', {
    params: { ...params }
  }).then(value => value.data)
    .catch(reason => { return { data: [], page_number: 0, page_size: 0, total_items: 0, total_pages: 0 } })
}
